<template>
  <NavMenu
    :items="items"
  >
    <template #last>
      <b-nav-form class="ml-auto">
        <TypeaheadProjects style="min-width: 200px"/>
      </b-nav-form>
    </template>
  </NavMenu>
</template>

<script>
import NavMenu from '@/components/NavMenu.vue'
import TypeaheadProjects from '@/components/TypeaheadProjects.vue'
import { API_URL } from '@/services/constants.js'

export default {
  name: 'SiteMenuStaff',
  components: {
    NavMenu,
    TypeaheadProjects,
  },
  computed: {
    items() {
      if (!this.$store.state.user.user?.DS2) {
        return items
      }
      const [, , ...remaining] = items
      return [
        { name: "Dashboard", to: `/dashboard` },
        { name: "Projects", to: `/projects2` },
        ...remaining,
      ]
    },
  },
}

const items = [
  {
    "name": "Dashboard",
    "href": `${API_URL}dashboard`,
  },
  {
    "name": "Projects",
    "href": `${API_URL}projects`,
  },
  {
    "name": "Art",
    "to": '/',
    "exact": true
  },
  {
    "name": "Collections",
    "to": "/collections",
  },
  {
    "name": "Manage",
    "to": "/manage",
    "auth": "staff"
  },
  {
    "name": "Upload",
    "to": "/manage/upload/new",
    "auth": "staff"
  },
  {
    "name": "Artist Portal",
    "to": "/artist"
  }
]
</script>
